import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

interface TaskFormHeaderProps {
  editingTaskId?: string | null;
  onClose: () => void;
}

const TaskFormHeader = ({ editingTaskId, onClose }: TaskFormHeaderProps) => {
  return (
    <div className="flex justify-between items-center mb-4">
      <h2 className="text-xl font-bold">
        {editingTaskId ? 'Rediger opgave' : 'Opret ny opgave'}
      </h2>
      <Button variant="ghost" size="icon" onClick={onClose}>
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default TaskFormHeader;